import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import Input from '../utils/Input';
import { addArticlesCashCategory, setAddArticlesCashCategory } from '../../action/handbook';
import cn from 'classnames';
import ErrorContainer from '../utils/ErrorContainer';
import Switch from '../utils/Switch';

class AddArticlesCashCategory extends Component {
    componentWillUnmount() {
        this.props.setAddArticlesCashCategory({});
    }
    
    renderSubHeader() {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                <div className="kt-subheader__main">
                    <h3 className="kt-subheader__title">Добавить категорию кассовых статей</h3>
                    <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                    <div className="kt-subheader__group" id="kt_subheader_search">
                        <span className="kt-subheader__desc">
                        </span>
                    </div>
                </div>        
                <div className="kt-subheader__toolbar">
                    <button onClick={() => this.props.history.push('/handbook/articlesCashCategories')} className="btn btn-default btn-bold">
                        Назад
                    </button>
                </div>
            </div>
            </div>
        );
    }

    isValid() {
        const { name } = this.props.addForm;
        if (name) return true;
        return false;
    }

    setData = (field) => (e) => {
        const data = {...this.props.addForm};
        data[field] = e.target.value;
        this.props.setAddArticlesCashCategory(data);
    }

    onChangeSwitch = (field) => (e) => {
        const data = {...this.props.addForm};
        data[field] = e;

        if (field === 'controlled' && e === true) data.uncontrolled = false;
        if (field === 'uncontrolled' && e === true) data.controlled = false;
        
        this.props.setAddArticlesCashCategory(data);
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.addArticlesCashCategory(this.props.addForm).then(result => {
            if (result) this.props.history.push('/handbook/articlesCashCategories');
        });
    }    

    render() {
        return (
            <Fragment>
                { this.renderSubHeader() }
                <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">                    
                <div className="kt-portlet">
                    <form onSubmit={this.onSubmit} className="kt-form">
                        <div className="kt-portlet__body">  
                            <div className="row">
                                <div className="col-md-4">
                                    <Input
                                        label="Название"
                                        required={true}
                                        onChange={this.setData('name')}
                                        value={this.props.addForm.name}
                                        placeholder="Название..."
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <label className="col-12 col-form-label">Контролируемые расходы</label>
                                    <div className="col-12">
                                        <Switch disabled={this.props.addForm.uncontrolled} onChange={this.onChangeSwitch('controlled')} checked={this.props.addForm.controlled}/>
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <label className="col-12 col-form-label">Неконтролируемые расходы</label>
                                    <div className="col-12">
                                        <Switch disabled={this.props.addForm.controlled} onChange={this.onChangeSwitch('uncontrolled')} checked={this.props.addForm.uncontrolled}/>
                                    </div>
                                </div>
                            </div>                   
                        </div>
                        <ErrorContainer field="addArticleCashCategory" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button
                                    disabled={!this.isValid() || this.props.loading}
                                    type="submit"
                                    className={cn({ 'btn btn-brand  kt-spinner--right kt-spinner--sm kt-spinner--light': true, 'kt-spinner': this.props.loading })}>
                                    Добавить
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = state => ({
    addForm: state.handbook.add,
    loading: state.loaders.addArticlesCashCategory
});

const mapDispatchToProps = {
    setAddArticlesCashCategory: (data) => setAddArticlesCashCategory(data),
    addArticlesCashCategory: (data) => addArticlesCashCategory(data)
}

export default connect(mapStateToProps, mapDispatchToProps)(AddArticlesCashCategory);